import { type ReactNode, useCallback } from 'react';
import { cn, Dialog } from '@prenuvo/halo';

type FctDialogClassName = {
  body?: string;
  content?: string;
  header?: string;
  title?: string;
};

export type FctDialogProps = {
  children: ReactNode;
  className?: FctDialogClassName;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  title: string;
  trigger?: ReactNode;
};

export function FctDialog({
  children,
  className,
  onOpenChange,
  open,
  title,
  trigger,
}: FctDialogProps) {
  const initialFocusRef = useCallback((el: HTMLSpanElement | null) => {
    el?.focus();
  }, []);

  return (
    <Dialog
      className={{
        body: cn('bg-fct-container dark:bg-fct-container w-206', className?.body),
        content: cn('h-auto w-206 max-w-max overflow-y-auto', className?.content),
        header: cn(
          'bg-fct-container dark:bg-fct-container items-center p-6 text-lg text-neutral-50 dark:text-neutral-50',
          className?.header,
        ),
        title: cn('mr-10 text-lg font-normal md:text-lg', className?.title),
      }}
      onOpenChange={onOpenChange}
      open={open}
      title={title}
      trigger={trigger}
    >
      <span aria-hidden="true" className="sr-only" ref={initialFocusRef} tabIndex={-1} />
      {children}
    </Dialog>
  );
}
